export const DIALOG_OPEN_BUTTON_ID_PREFIX = 'rental-start-dialog-open-button-';
export const DIALOG_ID_PREFIX = 'rental-start-dialog-';
